
 import { useState, useEffect } from 'react';
 import { TrasparenzaESG } from '../apiTypes';
 import { readElementsTrasparenzaESG } from '../functionApi';
 import { useAxiosInterceptor } from '../wrappers';

 export const useElementTrasparenzaEsgDettaglio = (reportId?: string, componentId?: string, elementId?: string) => {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [elements, setElements] = useState<TrasparenzaESG[]>([]);
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState<string | null>(null);
 
   useEffect(() => {
     if (!reportId || !componentId || !elementId) return;
 
     const loadElements = async () => {
       setLoading(true);
       try {
         const data = await readElementsTrasparenzaESG(reportId, componentId, elementId); 
         setElements(data);
         setError(null);
       } catch (err) {
         setError('Errore nel caricamento degli elementi');
         console.error(err);
       } finally {
         setLoading(false);
       }
     };
 
     loadElements();
   }, [reportId, componentId, elementId]);
 
   return { elements, loading, error };
 };
 
 


export default useElementTrasparenzaEsgDettaglio